import { FC, HTMLProps } from 'react';
import classNames from 'classnames';
import { getIsCurrentCardBlockedSelector, useAppSelector } from 'store';
import styles from './index.module.scss';

type RadabankCardPreviewProps = HTMLProps<HTMLDivElement> & {
	isMultiCard?: boolean;
	isShowBlockedOpacity?: boolean;
	isZp?: boolean;
}

export const RadabankCardPreview: FC<RadabankCardPreviewProps> = ({
	className,
	isMultiCard = false,
	isShowBlockedOpacity = true,
	children,
	isZp = false,
	...props
}) => {
	const isCardBlocked = useAppSelector(getIsCurrentCardBlockedSelector);

	return (
		<div
			{...props}
			className={classNames(styles.wrapper, 'radabank-card-preview', className, {
				[styles.blocked]: isShowBlockedOpacity && isCardBlocked,
				[styles.iszp]: isZp && !isMultiCard,
				[styles.multicard]: isMultiCard,
			})}
		>
			{children}
		</div>
	);
};
